import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  glass?: boolean;
}

const StyledCard = styled(motion.div)<CardProps>`
  background: ${({ glass }) => 
    glass 
      ? 'rgba(255, 255, 255, 0.1)' 
      : theme.colors.white
  };
  border-radius: ${theme.borderRadius.xl};
  padding: ${theme.spacing['2xl']};
  box-shadow: ${theme.shadows.md};
  position: relative;
  
  ${({ glass }) => glass && `
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  `}

  ${({ hover }) => hover && `
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: ${theme.shadows.xl};
    }
  `}

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing.xl};
  }
`;

export const Card: React.FC<CardProps> = ({
  children,
  className,
  hover = false,
  glass = false,
}) => {
  return (
    <StyledCard
      className={className}
      hover={hover}
      glass={glass}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      {children}
    </StyledCard>
  );
};